<template>
    <BaseLayout>
        <div class="container py-5">
            <div class="col-lg-5 col-md-7 mx-auto">
                <div class="shadow rounded-4 p-lg-5 p-3">
                    <div class="text-center mb-4">
                        <h1 class="ff-dsb fs-36 text-primary">Log In</h1>
                        <p class="fs-20">Enter your email and password to log in.</p>
                    </div>
                    <form @submit.prevent="submit" class="vstack gap-4">
                        <div>
                            <label for="inputEmail" class="form-label">Email</label>
                            <input id="inputEmail" type="email" inputmode="email" v-model="loginForm.email" class="form-control" :class="errors.email ? 'is-invalid':''" placeholder="mail@example.com" value="" autofocus>
                            <div v-if="errors.email" class="invalid-feedback">
                                {{ errors.email }}
                            </div>
                        </div>
                        <div>
                            <label for="inputPassword" class="form-label">Password</label>
                            <div class="input-group">
                                <input :type="showPassword ? 'text':'password'" name="password" v-model="loginForm.password" class="form-control z-0" :class="errors.password ? 'is-invalid':''" placeholder="enter password" id="inputPassword">
                                <button type="button" class="input-group-text rounded-end" @click="showPassword = !showPassword">
                                    <i class="fas fa-sm" :class="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                                </button>
                                <div v-if="errors.password" class="invalid-feedback">
                                    {{ errors.password }}
                                </div>
                            </div>
                        </div>
                        
                        <!-- <div class="form-check text-start">
                            <input class="form-check-input" type="checkbox" name="remember" v-model="loginForm.remember" value="1">
                            <label class="form-check-label" for="inputRememberMe">Remember Me</label>
                        </div> -->
                        <Link class="text-end" :href="route('user.password.request')">
                            Forgot Password?
                        </Link>

                        <div class="text-center">
                            <button class="btn btn-gradient-primary fs-15 px-5 py-3 rounded-4" type="submit" :disabled="loginForm.processing">
                                Sign In <i v-if="loginForm.processing" class="fad fa-spinner-third fa-spin"></i>
                            </button>
                        </div>
                        <div class="text-center">
                            Dont't have an account?
                            <Link :href="route('user.register')">
                                Sign up
                            </Link>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </BaseLayout>
</template>

<script setup>
import { useReCaptcha } from 'vue-recaptcha-v3';
import { useForm, Link  } from '@inertiajs/vue3';
import BaseLayout from '../../../../../../resources/js/front/Layouts/BaseLayout.vue';
import { ref } from 'vue';

const props = defineProps({ errors : Object })
const { executeRecaptcha, recaptchaLoaded } = useReCaptcha()
const showPassword = ref(false);

const loginForm = useForm({
    email: null,
    password: null,
    remember: false,
    g_recaptcha_response: null,
})

async function submit() {
    await recaptchaLoaded()
    loginForm.g_recaptcha_response = await executeRecaptcha('login')
    loginForm.post(route('user.login'))
}
</script>